module.exports = __webpack_public_path__ + "static/media/5.95f86428.jpg";